import { BrandDTO, ProductDTO, ProjectDTO } from '../../models'

export enum StatsTableColType {
    MAIN = 'main',
    PRIMARY = 'primary',
    SECONDARY = 'secondary'
}

export type StatsTableEntityObject = ProjectDTO | ProductDTO | BrandDTO

export type StatsTableSearchProps = {
    projectIds: number[]
    productIds: number[]
}

export const statsTableInitialSearchProps: StatsTableSearchProps = {
  projectIds: [],
  productIds: []
}

export enum DraggableColLabels {
    STORE = 'Store',
    PROJECT = 'Project',
    PRODUCTS = 'Products'
}

export type StatsTableSettings = {
    draggableColumnsCount: number
    mainEntityColLabel: DraggableColLabels
    primaryCorrespondingEntityColLabel: DraggableColLabels
    secondaryCorrespondingEntityColLabel?: DraggableColLabels
}

export type SelectedCorrespondingEntitySets = {
    [DraggableColLabels.PROJECT]: Set<number>
    [DraggableColLabels.STORE]: Set<number>
    [DraggableColLabels.PRODUCTS]: Set<number>
}

export type SelectedCorrespondingEntitiesMap = Map<
    number,
    SelectedCorrespondingEntitySets
    >

export interface FilterOptionSettings {
    showImageForMain?: boolean
    showImageForPrimary?: boolean
    showImageForSecondary?: boolean
    skipPrimaryEntityGrouping?: boolean
}

export interface ColumnFilterSelections {
    main: Set<number>
    mainFull: Set<number>
    primary: Set<string>
    primaryFull: Set<string>
    secondary: Set<string>
    secondaryFull: Set<string>
}